declare global {
  interface Window {
    fbq: (...args: unknown[]) => void
    _fbq: (...args: unknown[]) => void
  }
}

let initialized = false

export function initMetaPixel(pixelId: string): void {
  if (initialized) return
  initialized = true

  const f = window
  const b = document
  const n = (f.fbq = function (...args: unknown[]) {
    if (n.callMethod) {
      n.callMethod.apply(n, args)
    } else {
      n.queue.push(args)
    }
  }) as typeof f.fbq & {
    callMethod?: (...args: unknown[]) => void
    queue: unknown[][]
    push: (...args: unknown[]) => void
    loaded: boolean
    version: string
  }

  if (!f._fbq) f._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []

  const t = b.createElement('script')
  t.async = true
  t.src = 'https://connect.facebook.net/en_US/fbevents.js'
  const s = b.getElementsByTagName('script')[0]
  s?.parentNode?.insertBefore(t, s)

  window.fbq('init', pixelId)
}

export function trackPageView(): void {
  if (window.fbq) {
    window.fbq('track', 'PageView')
  }
}

export function trackAddToCart(params?: Record<string, unknown>): void {
  if (window.fbq) {
    window.fbq('track', 'AddToCart', params)
  }
}
